<template>
  <div>
    <div class="assessment-banner">
      <img alt="" src="@/assets/img/dc/banner.png"/>
    </div>
    <div style="height: 10px"></div>
    <el-card shadow="never"
             class="aui-card--fill">

      <div style="height: 10px"></div>

      <!-- 步骤数据 -->
      <div class="divApply">
        <el-form status-icon :model="dataForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <el-col :span="2" class="container" style="height: 10px">
              <div class="dialog"></div>
            </el-col>
            <el-col :span="15">
              <div  style="height: 32px; line-height: 32px; font-weight: 700; display: inline-block;">
                步骤1：选择评估职位
              </div>
              <div style="width: 5px;display: inline-block;"></div>
              <div style="display: inline-block;">
                <el-form-item label-width="1px" label="">
                  <el-select v-model="dataForm.jobId"
                             @change="assessmentJobChange"
                             :placeholder="$t('user.select')"
                             clearable>
                    <el-option v-for="(item,index) in keyPositionArrs"
                               :key="index"
                               :label="item.positionCode + '-' +item.positionName"
                               :value="item.positionId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>

          </el-row>

          <div style="height: 50px"></div>

          <!-- 选择用户 -->
          <el-row>
            <el-col :span="2" class="container" style="height: 10px">
              <div class="dialog"></div>
            </el-col>
            <el-col :span="15">
              <div style="height: 32px; line-height: 32px;; font-weight: 700 ;display: inline-block;">
                步骤2：选择被评估人
              </div>
              <div style="display: inline-block; width: 5px;"></div>
              <div style="display: inline-block;">
                <el-form-item label-width="1px" label="">
                  <el-button type="primary"
                             @click="addUser()">请选择
                  </el-button>
                </el-form-item>
              </div>
            </el-col>

          </el-row>
          <!-- 表单 -->
          <el-row>
            <el-col :span="2" class="container" style="height: 10px">
              <div class="dialog"></div>
            </el-col>
            <el-col :span="20">
              <el-table :data="dataList"
                        border
                        v-loading="dataListLoading">

                <!-- 员工ID -->
                <el-table-column prop="userCode"
                                 :label="$t('user.userID')"
                                 header-align="center"
                                 align="center"></el-table-column>
                <!-- 员工卡号 -->
                <el-table-column prop="userCardNo"
                                 :label="$t('user.userCardNo')"
                                 header-align="center"
                                 align="center"></el-table-column>
                <!-- 姓名 -->
                <el-table-column prop="userNameCn"
                                 :label="$t('user.name')"
                                 header-align="center"
                                 align="center"></el-table-column>
                <!-- 证件编号 -->
                <el-table-column prop="cardNo"
                                 :label="$t('areaManager.passportIdcard')"
                                 header-align="center"
                                 align="center"></el-table-column>
                <!-- 主要职位 -->
                <el-table-column prop="positionName"
                                 :label="$t('user.position')"
                                 header-align="center"
                                 align="center"></el-table-column>
                <!-- 操作 -->
                <el-table-column label="操作"
                                 fixed="right"
                                 header-align="center"
                                 align="center"
                                 width="100">
                  <template slot-scope="scope">
                    <el-link type="primary"  :underline="false"
                             @click="deleteRow(scope.$index, dataList)">删除
                    </el-link>
                  </template>
                </el-table-column>
                <!-- 兼职职位1 -->
              </el-table>
            </el-col>
          </el-row>
          <div style="height: 50px"></div>

          <!-- 联系方式 -->
          <el-row>
            <el-col :span="2" class="container" style="height: 10px">
              <div class="dialog"></div>
            </el-col>
            <el-col :span="22">
              <div style="height: 32px; line-height: 32px; font-weight: 700;display: inline-block;">
                步骤3：添加测评联系人
              </div>
              <div style="width: 5px;display: inline-block;"></div>
              <div style="display: inline-block;">
                <el-form-item label-width="0px" label="">
                  <el-select v-model="dataForm.contact"
                             :placeholder="$t('user.select')"
                             clearable>
                    <el-option v-for="(item,index) in contactList"
                               :key="index"
                               :label="item.privacyContact"
                               :value="item.contact">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div style="display: inline-block">
                <div style="height: 32px; line-height: 32px;">
                  &nbsp;&nbsp;该信息将用作宝马评估中心与经销商联络测评事宜使用。
                </div>
              </div>
            </el-col>

          </el-row>

          <div style="height: 50px"></div>

          <!-- 政策 -->
          <el-row>
            <el-col :span="2" class="container" style="height: 10px">
              <div class="dialog"></div>
            </el-col>
            <el-col :span="15" class="assessmentPolicyClick">
              <el-checkbox @change="assessmentPolicyClick" v-model="assessDetailchecked"></el-checkbox>
              <el-link @click="viewPolicyOK" type="primary" :underline="false">同意被评估人查看本人能力评估报告 《隐私政策》</el-link>
            </el-col>

          </el-row>
          <div style="height: 50px"></div>
          <!-- 确定按钮 -->
          <el-row>
            <el-col :span="10" class="container" style="height: 10px">
              <div class="dialog"></div>
            </el-col>
            <el-col :span="5">
              <div class="search">
                <!-- 确认 -->
                <el-button type="primary"
                           @click="confirm()">{{ $t('assessment.confirm') }}
                </el-button>
                <!-- 取消 -->
                <el-button plain
                           class="el-button-columnBtn"
                           @click="cancel()">{{ $t('assessment.cancel') }}
                </el-button>
              </div>
            </el-col>
          </el-row>

          <div style="height: 50px"></div>
        </el-form>
      </div>

      <!-- 弹窗, 新增 / 修改 -->
      <addUser v-if="addOrUpdateVisible"
               ref="addUser"
               @func="acquireUser"></addUser>
      <!-- 弹窗, 政策 -->
      <assessmentDetailPolicy @func="assessmentDetailEmit"
                              @funcNO="assessmentDetailEmitNO"
                              ref="refAssessmentDetailPolicy"></assessmentDetailPolicy>

      <!-- 弹窗, 政策 确定按钮 -->
      <assessmentDetailPolicyOK @func="assessmentDetailEmitOK"
                                ref="refAssessmentDetailPolicyOK"></assessmentDetailPolicyOK>

    </el-card>
  </div>
</template>
<script>
  import mixinViewModule from '@/mixins/view-module'
  import addUser from './addUser'
  import assessmentDetailPolicy from "../assessment/assessmentDetailPolicy";
  import assessmentDetailPolicyOK from "../assessment/assessmentDetailPolicyOK";

  export default {
    mixins: [mixinViewModule],
    data() {
      return {
        mixinViewModuleOptions: {
          activatedIsNeed: false,
          getDataListURL: '',
          getDataListIsPage: true,
        },
        dataForm: {},
        keyPositionArrs: [],
        dataListLoading: false,
        dataList: [],
        userList: [],
        contactList: [],
        addOrUpdateVisible: false,
        assessDetailchecked:false,// 政策勾选状态
      }
    },
    components: {
      addUser,
      assessmentDetailPolicy: assessmentDetailPolicy,
      assessmentDetailPolicyOK: assessmentDetailPolicyOK
    },
    computed: {
      dataRule() {
      }
    },
    created() {
      // this.$request.get('/sys/commposition/keyPosition')
      //   .then((res, total, code, data) => {
      //     this.keyPositionArrs = res
      //     this.keyPositionArrs = JSON.parse(JSON.stringify(this.keyPositionArrs))
      //   }).catch(() => {
      // })
      this.init()

    },
    mounted() {
      this.$eventHub.$on('assessmentCenter', data => {
        this.initShow()
      })
    },
    methods: {
      acquireUser(data) {
        this.dataList = data;

        this.userList = data
        let orgId = this.dataList[0].orgId
        this.$request.get('/sys/org/queryContact', {
          orgId: orgId
        }).then((res, total, code) => {
          // 联系方式清空
          this.$set(this.dataForm,'contact','')
          this.contactList = res
          this.contactList = JSON.parse(JSON.stringify(this.contactList))
        }).catch((err) => {
          console.log(err)
        })


        // dataList.forEach(item => {
        //     this.userList.push(item.userId,item.userCode,item.cardNo,item.userNameCn)
        //   })
      },
      // 清空数据
      initShow() {
        this.dataForm = {}
        this.keyPositionArrs = []
        this.dataListLoading = false
        this.dataList = []
        this.userList = []
        this.contactList = []
        this.addOrUpdateVisible = false
        this.init()
      },
      // 初始化
      init(){
        this.$request.get('/sys/commposition/keyPosition')
          .then((res, total, code, data) => {
            this.keyPositionArrs = res
            this.keyPositionArrs = JSON.parse(JSON.stringify(this.keyPositionArrs))
          }).catch((err) => {
            console.log(err)
        })
      },
      addUser() {
        if (this.dataForm.jobId === '' || this.dataForm.jobId === undefined ||  this.dataForm.jobId === null) {
          let message = '请选择评估职位'
          this.$alert(message, this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.addOrUpdateVisible = true
          this.$nextTick(() => {
            this.$refs.addUser.init()
            this.$refs.addUser.jobId = this.dataForm.jobId
          })
        }
      },

      // 行删除
      deleteRow(index, rows) {
        this.$confirm(this.$t('prompt.info', {'handle': this.$t('delete')}), this.$t('prompt.title'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }).then(() => {
          rows.splice(index, 1);
          // 联系方式清空
          this.$set(this.dataForm,'contact','')
          // 数组清空
          this.contactList = []
        }).catch((err) => {
          console.log(err)
        })
      },

      unique(arr) {
        const map = new Map();
        return arr.filter((arr) => !map.has(arr.userCode) && map.set(arr.userCode, 1))
      },
      confirm() {
        if (this.dataForm.jobId === '' || this.dataForm.jobId === undefined) {
          let message = '请选择评估职位'
          this.$alert(message, this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
        } else if (this.dataForm.contact === '' || this.dataForm.contact === undefined) {
          let message = '请添加管理员联系方式'
          this.$alert(message, this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
        } else if (this.userList.length === 0) {
          let message = '请选择要添加的用户'
          this.$alert(message, this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
        } else {
          let viewReport
          if(this.assessDetailchecked){
            viewReport = '1'
          }else {
            viewReport = '0'
          }
          this.$request.post(
            '/acdc/candidate/startCandidate',
            {
              jobId: this.dataForm.jobId,
              contact: this.dataForm.contact,
              viewReport: viewReport,
              userList: this.userList
            }
          ).then((res, tota, code, data) => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500
            })
            if (code === 1) {
              this.tabRemove()
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      },

      // 评估职位修改后清空被评估人
      assessmentJobChange(){
        console.log('assessmentJobChange')
        console.log(this.dataForm.jobId)
        // 用户清空
        this.dataList = []
        this.userList = []

        // 联系方式清空
        this.$set(this.dataForm,'contact','')
        // 数组清空
        this.contactList = []
        // this.$set(this.authenticationFrom,'contact','')
      },

      // 打开评估详情政策
      assessmentPolicyClick() {
        console.log(this.assessDetailchecked)
        // 点击打开政策
        if(this.assessDetailchecked){
          this.$refs.refAssessmentDetailPolicy.init()
        }else {
          // 调用删除接口
          this.$message.info('去掉勾选后，候选人将无法查看本人能力评估报告')
        }
      },

      // 弹出确定的政策
      viewPolicyOK() {
        this.$refs.refAssessmentDetailPolicyOK.init()
      },
      // 政策回掉 确定
      assessmentDetailEmit(data) {
        this.assessDetailchecked = data
      },
      // 政策回掉 取消。
      assessmentDetailEmitNO(data) {
        this.assessDetailchecked = data
      },

      // 政策回掉 确定
      assessmentDetailEmitOK(data) {
        // this.assessDetailchecked = data
      },

      // 删除当前页面
      tabRemove() {
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
          return false
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
          item => item.name !== tabName
        )
        if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
            'home'
          return false
        }
        // 当前选中tab被删除
        if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name})
        }
      },
      cancel() {
        this.dataList = ''
          this.userList = ''
        this.tabRemove()
      }
    }
  }
</script>
<style>
  .dialog {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    font-size: 14px;
    white-space: normal;
    font-weight: 900;
  }

  .divApply .el-form-item {
    width: 100% !important;
  }

  .assessmentPolicyClick .el-checkbox {
    font-size: 14px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-right: 5px;
  }

  .assessment-banner {
    position: relative;
  }

  .assessment-banner img {
    display: inline-block;
    width: 100%;
  }

</style>
